export default __webpack_public_path__ + "static/media/Wrench.5daa27e5.svg";